import React from "react";
import BallScalePulse from "./BallScalePulse";

const OverlayLoader = () => {
    return (
        <div className="blur-overlay">
            <BallScalePulse customStyles="la-2x la-green" />
        </div>
    );
};

export default OverlayLoader;
